export default function cleanSlashes(urlString: string) {
  return urlString.replace(/(^\/)|(\/$)/g, '')
}
